import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  removeElement(event) {
    const card = event.target.closest(".question-card, .option-row")
    if (!card) return

    const idInput = card.querySelector("input[name$='[id]']")
    if (idInput) {
      const destroyInput = document.createElement("input")
      destroyInput.type = "hidden"
      destroyInput.name = idInput.name.replace("[id]", "[_destroy]")
      destroyInput.value = "1"
      card.appendChild(destroyInput)
      card.style.display = "none"
    } else {
      card.remove()
    }
  }
}
